import React from "react";

export const Marquee = ({ items = [], accent = "yellow" }) => {
  const color = accent === "red" ? "text-[#E60000]" : "text-[#FFCC00]";
  const repeated = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-[#27272A] bg-black py-5">
      <div className="flex w-max animate-marquee">
        {repeated.map((it, i) => (
          <div
            key={i}
            className="flex items-center gap-6 px-8 font-display text-2xl md:text-3xl tracking-widest text-white whitespace-nowrap"
          >
            <span>{it}</span>
            <span className={`${color}`}>/</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
